import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {CourseService} from '@app/@core/services/course.service';
import {Observable} from 'rxjs';
import {SelectItemGroup} from 'primeng/api';
import {map} from 'rxjs/operators';

interface KV {
    id?: string;
    name?: string;
}

@Component({
    selector: 'app-course-select',
    template: `
        <ng-container *ngIf="multi;else templateSingle">
            <p-multiSelect [options]="groupedOptions$| async"
                           [(ngModel)]="courseId"
                           group="true"
                           [styleClass]="styleClass"
                           (ngModelChange)="changed($event)"
                           placeholder="Select a Courses"
                           selectedItemsLabel="{0} items selected">
            </p-multiSelect>
        </ng-container>

        <ng-template #templateSingle>
            <p-dropdown [options]="groupedOptions$| async"
                        [filter]="true"
                        [(ngModel)]="courseId"
                        [showClear]="true"
                        [styleClass]="styleClass"
                        (ngModelChange)="changed($event)"
                        group="true"
                        placeholder="Select a Course">
            </p-dropdown>
        </ng-template>

        <ng-template let-group pTemplate="group">
            <div class="text-center">
                <span class="text-primary">-- {{ group.label }} --</span>
            </div>
        </ng-template>
    `,
    styles: []
})
export class CourseSelectComponent implements OnInit {
    @Input() courseId: string | string[];
    @Input() multi = false;
    @Input() openOnly = false;
    @Input() styleClass: string;

    @Output() courseIdChange = new EventEmitter<string | string[]>();
    @Output() onChanged = new EventEmitter<KV | KV[]>();

    groupedOptions$: Observable<SelectItemGroup[]>;

    constructor(private courseService: CourseService) {
    }

    ngOnInit(): void {
        if (this.openOnly) {
            this.groupedOptions$ = this.courseService.groupedOptions$;
        }else {
            this.groupedOptions$ = this.courseService.groupedOptions$.pipe(
                map((groupedOptions: SelectItemGroup[]) => {
                    return groupedOptions.filter(groupedOption => groupedOption.label === 'OPEN');
                })
            );
        }
    }

    changed($event: any) {
        this.courseIdChange.emit(this.courseId);

        if (this.courseId) {
            if (Array.isArray(this.courseId)) {
                const kvs = this.courseId.map((id: string) => ({id, name: this.courseService.getName(id)} as KV));
                this.onChanged.emit(kvs);
            } else {
                this.onChanged.emit({id: this.courseId, name: this.courseService.getName(this.courseId)});
            }
        } else {
            this.onChanged.emit({});
        }
    }
}
